import { render } from "./AccessDeniedView.vue?vue&type=template&id=e0902078&scoped=true"
import script from "./AccessDeniedView.vue?vue&type=script&lang=js"
export * from "./AccessDeniedView.vue?vue&type=script&lang=js"

import "./AccessDeniedView.vue?vue&type=style&index=0&id=e0902078&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0902078"]])

export default __exports__